<template>
  <div class="pie-content">
    <div class="result-chart" id="result-chart" ref="resultChart"> </div>
    <div class="percent" :style="{ fontSize: fontSize + 'px' }"
      >{{ kcalNum }}<br />Kcal</div
    >
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    fontSize: {
      type: String | Number,
      default: '20'
    },
    data: {
      type: Array,
      default: () => []
    },
    kcalNum: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {}
  },

  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      option = {
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['81%', '100%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: this.data
          }
        ]
      }

      var chartDom = this.$refs.resultChart
      var myChart = echarts.init(chartDom, null, { renderer: 'svg' })
      var option
      option && myChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.pie-content {
  width: 100%;
  height: 100%;
  position: relative;

  .result-chart {
    width: 100%;
    height: 100%;
  }

  .percent {
    text-align: center;
    width: 89px;
    position: absolute;
    left: 50%;
    top: 50%;
    word-break: break-all;
    transform: translate(-50%, -50%);
    font-size: 20px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #333333;
    line-height: 20px;
  }
}
</style>
